import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage";
import WebsitePackage from "@/models/WebsitePackage/WebsitePackage";

export default class Image extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-package/image';

    /**
     *
     * @type {string}
     */
    static entity = 'websitePackageImages';

    static fields() {
        return {
            id: this.number(null).nullable(),
            sort_order: this.number(null).nullable(),
            website_package_id: this.number(null).nullable(),
            public_image_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            websitePackage: this.belongsTo(WebsitePackage, 'website_package_id'),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
        }
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PublicImage(){
        return this.getRelated('publicImage');
    }

}
